module.exports = __webpack_public_path__ + "img/homepage.2ce49e8c.png";